module.exports = __webpack_public_path__ + "static/assets/4bcaad0e552bbde77946d13df25af9c1.svg";